import type { PropsWithChildren } from 'react';

import { Box, type SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

interface ITabPanelProperties {
  index: number;
  value: number;
  sx?: SxProps<Theme>;
}

export const TabPanel = ({
  index,
  value,
  sx = {},
  children,
  ...properties
}: PropsWithChildren<ITabPanelProperties>) => (
  <Box
    aria-labelledby={`simple-tab-${index}`}
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    role="tabpanel"
    {...properties}
  >
    {value === index ? <Box sx={{ p: 3, ...sx }}>{children}</Box> : null}
  </Box>
);
